import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { List, ListItem, ListItemText, Typography } from "@material-ui/core";
import { MSpinner, MDropzone, ActionButtons, MCard } from "components/Shared";
import { xlsxToWorkbook, workbookToRowCount } from "components/Shared/Formatters/XLSX";
import xlsx from "xlsx";
import { uploadBatchOrder } from "requests/customer";
import responseHandler from "responseHandler";

const orderColumns = [
  "PolicyID",
  "PolicyNumber",
  "InsuredName",
  "MailingAddress1",
  "MailingAddress2",
  "MailingCity",
  "MailingState",
  "MailingZip",
  "SurveyAddress1",
  "SurveyAddress2",
  "SurveyCity",
  "SurveyState",
  "SurveyZip",
  "InsuredPhone",
  "BusinessType",
  "SurveyType",
  "EffectiveDate",
  "CoverageIn",
  "AgentCode",
  "AgentName",
  "AgentPhone",
  "YearBuilt",
  "UnderwriterCode",
  "Supplements",
  "Comments",
  "InsuredPhone2",
  "OrderCodeIn",
  "CustomerNumber",
  "StartDate",
  "DueDate",
  "Rush",
  "PolicyholderEmail",
  "AssignToInspector",
  "SquareFeet",
  "AgentEmail",
  "DesignatedContactName",
  "DesignatedContactPhone1",
  "DesignatedContactPhone2",
  "DesignatedContactEmail",
];

const { EXCEL } = MDropzone.fileTypes;

const Batch = props => {
  const [{ clear, files, errors }, setDropzoneFunctions] = useState({ clear: () => { }, files: [], errors: [] });
  const [fileToUpload, setFileToUpload] = useState(null);
  const [rowCount, setRowCount] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitErrorMessages, setSubmitErrorMessages] = useState([]);
  const mounted = useRef(true);

  const submitDisabled = files.length === 0 || errors.length > 0;
  const resetDisabled = files.length === 0;

  useEffect(() => {
    const parseWorkbook = async () => {
      const workbook = await xlsxToWorkbook(files[0].file);
      setRowCount(workbookToRowCount(workbook)[0]);
      setFileToUpload(workbook);
    };
    if (files[0]) {
      parseWorkbook();
    }
  }, [files.length]
  );

  useEffect(() => {
    props.setErrors(errors);
  }, [errors]);

  const submitOrder = order => {
    const payload = new Blob([xlsx.write(order, { bookType: 'xlsx', bookSST: 'false', type: 'array' })]);

    setSubmitErrorMessages([]);
    setIsSubmitting(true);
    uploadBatchOrder(payload, response => {
      if (!response.error) {
        props.makeToast(`Order Was Submitted For ${rowCount} Record(s)`, 'success');
      }
      else {
        setSubmitErrorMessages(response.errorMessages);
      }      
      setIsSubmitting(false);
      setFileToUpload(null);
      setRowCount(0);
    }, () => {
      setIsSubmitting(false);
      setFileToUpload(null);
      setRowCount(0);
    }, mounted);
  };

  const promptElement = (
    <div>
      <div>Drop completed template here to upload.</div>
      <div style={{textTransform:"none"}}>The import template has been updated; please be sure to download the latest version before you begin.</div>
    </div>
  );

  return (
    <MCard
      title="Batch Order"
      className="batch-order">
      <>
        {isSubmitting ? (
          <div className={'batch-order-lhs processing'}>
            <Typography>
              {`Proccessing ${rowCount} Record(s)`}
            </Typography>
            <MSpinner />
          </div>
        ) : (
            <div className={"file-manager"}>
              <MDropzone
                className={'batch-order-lhs'}
                setDropzoneProperties={setDropzoneFunctions}
                onFileAdd={() => { }}
                onFileRemove={() => setFileToUpload(null)}
                prompt={promptElement}
                validFileTypes={{
                  type: EXCEL,
                  options: {
                    sheets: [
                      {
                        columns: orderColumns,
                      },
                    ],
                  }
                }}
                trackFiles
              />
            </div>
          )}
        <ActionButtons
          buttonPropSets={[
            {
              className: "batch-order-template-button",
              children: 'Download Template',
              href: 'https://mueller.blob.core.windows.net/public/MR-StandardImport-V202505.xlsx'
            },
            {
              disabled: submitDisabled,
              onClick: () => submitOrder(fileToUpload),
              children: 'Submit',
              tooltipProps: {
                title: 'Send File For Processing',
              },
              dialogProps: {
                title: 'Order Confirmation',
                children: (
                  <Typography>
                    {`Submit Order For ${rowCount} Record(s)?`}
                  </Typography>
                ),
              },
            },
            {
              disabled: resetDisabled,
              onClick: () => { clear(); setFileToUpload(null); },
              children: 'Clear',
              tooltipProps: {
                title: 'Remove File',
              },
            },
          ]}
        />
        {submitErrorMessages.length > 0 &&
        <List>
          {submitErrorMessages.map((em, i) => 
          <ListItem key={`row-${i}`}>
            <ListItemText primary={em} primaryTypographyProps={{color:"error"}} />
          </ListItem>
          )}
        </List>
        }
      </>
    </MCard>
  );
};

Batch.propTypes = {
  makeToast: PropTypes.func,
  setErrors: PropTypes.func,
};

const mdtp = (dispatch) => ({
  makeToast(text, type) {
    responseHandler.customToast(text, type, dispatch);
  },
});

export default connect(null, mdtp)(Batch);